import { formatEther } from '@ethersproject/units';
import { useContext } from 'react';
import Button from '../../../../components/Button';
import Detail from '../../../../components/Detail';
import appContext from '../../../../context/app/appContext';
import modalContext from '../../../../context/modal/modalContext';
import { formatUSD } from '../../../../helpers/formats';
import useUserBalance from '../../../../hooks/web3/useUserBalance';

const Stake = () => {
    const { openModal } = useContext(modalContext);
    const { chainConfig } = useContext(appContext);

    const userBalance = useUserBalance(chainConfig.spoolToken);

    const stake = () => {
        openModal('stakeModal');
    };

    return (
        <Detail
            title='$SPOOL in Your Wallet'
            value={
                <>
                    {formatUSD(userBalance ? formatEther(userBalance) : 0)} $SPOOL
                    <Button
                        onClick={stake}
                        disabled={!userBalance || userBalance.isZero()}
                    >
                        Stake
                    </Button>
                </>
            }
        />
    );
};

export default Stake;
